module.exports = __webpack_public_path__ + "static/media/icon-confirm.828e4238.svg";